/* XLHat Theme — JavaScript */
'use strict';

/* ── Header scroll effect ─────────────────────────────── */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Mobile nav ───────────────────────────────────────── */
(function () {
  const toggle = document.querySelector('.header__menu-toggle');
  const nav    = document.querySelector('.mobile-nav');
  const close  = document.querySelector('.mobile-nav__close');
  if (!toggle || !nav) return;

  nav.setAttribute('aria-hidden', 'true');

  const openNav = () => {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (close) close.focus();
  };

  const closeNav = () => {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
  };

  toggle.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);

  nav.addEventListener('click', (e) => {
    if (e.target === nav) closeNav();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeNav();
  });
})();

/* ── Size guide modal ─────────────────────────────────── */
function openSizeGuide() {
  const modal = document.getElementById('size-guide-modal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    modal.querySelector('.modal__close').focus();
  }
}

function closeSizeGuide() {
  const modal = document.getElementById('size-guide-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeSizeGuide();
});

/* ── Quantity selector ────────────────────────────────── */
(function () {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const selector = btn.closest('.qty-selector');
    const input = selector?.querySelector('.qty-input');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    if (btn.dataset.action === 'plus')  val = val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // If inside a cart update form, auto-submit after a short debounce
    const cartForm = input.closest('form[action="/cart"]');
    if (cartForm) {
      clearTimeout(cartForm._qtyTimer);
      cartForm._qtyTimer = setTimeout(() => cartForm.submit(), 600);
    }
  });
})();

/* ── Variant selector ─────────────────────────────────── */
(function () {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.variant-btn');
    if (!btn) return;
    const group = btn.closest('.variant-buttons');
    if (!group) return;
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
})();

/* ── Product gallery thumbnails ───────────────────────── */
(function () {
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    const main    = gallery?.querySelector('.product-gallery__main img');
    if (!main) return;
    const src = thumb.querySelector('img')?.src;
    if (src) {
      main.src = src;
      gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    }
  });
})();

/* ── Scroll-reveal animations ─────────────────────────── */
(function () {
  if (!document.body.classList.contains('animate--page-in')) return;
  const sections = document.querySelectorAll('.section');
  if (!sections.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(s => observer.observe(s));
})();

/* ── Add to cart (AJAX) ───────────────────────────────── */
(function () {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    if (!btn) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    new URLSearchParams(new FormData(form))
      });

      if (!res.ok) throw new Error('Add to cart failed');

      // Update cart count
      const cartRes  = await fetch('/cart.js');
      const cartData = await cartRes.json();
      document.querySelectorAll('.header__cart-count').forEach(el => {
        el.textContent = cartData.item_count;
        el.style.display = cartData.item_count > 0 ? 'flex' : 'none';
      });

      // Brief success state
      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.removeAttribute('aria-disabled');
      }, 1600);

    } catch (err) {
      btn.textContent = 'Error — try again';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.removeAttribute('aria-disabled');
      }, 2000);
    }
  });
})();

/* ── Remove cart item ─────────────────────────────────── */
(function () {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.cart-item__remove');
    if (!btn) return;
    const lineKey = btn.dataset.key;
    if (!lineKey) return;
    await fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: lineKey, quantity: 0 })
    });
    window.location.reload();
  });
})();

/* ── Newsletter form ──────────────────────────────────── */
(function () {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.newsletter__form-el');
    if (!form) return;
    const input = form.querySelector('.newsletter__input');
    if (input && !input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });
})();

/* ── Collection filtering (price, category, tags) ────── */
(function () {

  function applyFilters() {
    const grid        = document.getElementById('CollectionGrid');
    if (!grid) return;

    const cards       = [...grid.querySelectorAll('.product-card-wrapper')];
    const noResults   = document.getElementById('NoFilterResults');
    const clearBtn    = document.getElementById('ClearAllFilters');

    const priceMin    = parseFloat(document.getElementById('PriceMin')?.value) || 0;
    const priceMax    = parseFloat(document.getElementById('PriceMax')?.value) || Infinity;

    const checkedTypes = [...document.querySelectorAll('.filter-type-checkbox:checked')]
      .map(cb => cb.value.toLowerCase());

    let visibleCount = 0;

    cards.forEach(card => {
      const price = parseFloat(card.dataset.price) || 0;
      const type  = (card.dataset.type || '').toLowerCase();

      const passPrice = price >= priceMin && price <= priceMax;
      const passType  = checkedTypes.length === 0 || checkedTypes.includes(type);

      const visible = passPrice && passType;
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';

    // Show clear button if any filter active
    const hasFilter = priceMin > 0 || priceMax < Infinity || checkedTypes.length > 0;
    if (clearBtn) clearBtn.style.display = hasFilter ? 'inline-flex' : 'none';
  }

  function clearFilters() {
    const priceMinEl = document.getElementById('PriceMin');
    const priceMaxEl = document.getElementById('PriceMax');
    if (priceMinEl) priceMinEl.value = '';
    if (priceMaxEl) priceMaxEl.value = '';

    document.querySelectorAll('.filter-type-checkbox, .filter-tag-checkbox')
      .forEach(cb => { cb.checked = false; });

    const panel   = document.getElementById('FiltersPanel');
    const baseUrl = panel?.dataset.collectionUrl;
    const sortBy  = panel?.dataset.sort;
    if (baseUrl) {
      let url = baseUrl;
      if (sortBy && sortBy !== 'manual') url += '?sort_by=' + sortBy;
      window.location.href = url;
    } else {
      applyFilters();
    }
  }

  // Price apply button
  document.addEventListener('click', (e) => {
    if (e.target.closest('#ApplyPriceFilter')) applyFilters();
    if (e.target.closest('#ClearAllFilters')) clearFilters();
  });

  // Price inputs — apply on Enter
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && (e.target.id === 'PriceMin' || e.target.id === 'PriceMax')) {
      applyFilters();
    }
  });

  // Category type checkboxes — instant apply
  document.addEventListener('change', (e) => {
    if (e.target.closest('.filter-type-checkbox')) {
      applyFilters();
    }
  });

  // Tag checkboxes — navigate to tag URL
  document.addEventListener('change', (e) => {
    const checkbox = e.target.closest('.filter-tag-checkbox');
    if (!checkbox) return;

    const panel   = document.getElementById('FiltersPanel');
    if (!panel) return;
    const baseUrl = panel.dataset.collectionUrl;
    const sortBy  = panel.dataset.sort;

    const checked = [...panel.querySelectorAll('.filter-tag-checkbox:checked')]
      .map(cb => encodeURIComponent(cb.value));

    let url = baseUrl;
    if (checked.length > 0) url += '/' + checked.join('+');
    if (sortBy && sortBy !== 'manual') url += '?sort_by=' + sortBy;
    window.location.href = url;
  });

})();

/* ── Expose globals ───────────────────────────────────── */
window.xlhat = { openSizeGuide, closeSizeGuide };

/* ── Hat Grid Pagination ──────────────────────────────── */
(function () {
  document.querySelectorAll('.hat-pagination').forEach(function (nav) {
    var gridId  = nav.dataset.grid;
    var grid    = document.getElementById(gridId);
    if (!grid) return;

    var perPage = parseInt(nav.dataset.perPage, 10)  || 8;
    var total   = parseInt(nav.dataset.total,   10)  || 0;
    var pages   = Math.ceil(total / perPage);
    var current = 1;

    var items   = grid.querySelectorAll('.hat-grid__item');
    var pagesEl = nav.querySelector('.hat-pagination__pages');
    var prevBtn = nav.querySelector('.hat-pagination__prev');
    var nextBtn = nav.querySelector('.hat-pagination__next');

    function showPage(page) {
      current = page;
      var start = (page - 1) * perPage;
      var end   = start + perPage;

      items.forEach(function (item, idx) {
        if (idx >= start && idx < end) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });

      renderPages();

      // Scroll to just above the section
      var section = grid.closest('.hat-grid-section');
      if (section) {
        var top = section.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    function renderPages() {
      if (!pagesEl) return;
      pagesEl.innerHTML = '';

      for (var i = 1; i <= pages; i++) {
        (function (p) {
          var btn = document.createElement('button');
          btn.className = 'hat-pagination__page' + (p === current ? ' active' : '');
          btn.textContent = p;
          btn.setAttribute('aria-label', 'Page ' + p);
          btn.setAttribute('aria-current', p === current ? 'page' : 'false');
          btn.addEventListener('click', function () { showPage(p); });
          pagesEl.appendChild(btn);
        })(i);
      }

      if (prevBtn) prevBtn.disabled = (current === 1);
      if (nextBtn) nextBtn.disabled = (current === pages);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (current > 1) showPage(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (current < pages) showPage(current + 1);
      });
    }

    // Boot: show first page
    showPage(1);
  });
})();
